/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import { OrganisationAvatarFragmentDoc } from '../../organisations/OrganisationAvatar.generated.js';
export type ProjectOverviewParticipantsBox_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, canInviteContractee: boolean, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, members: Array<{ __typename: 'CrmPerson', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }>, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } } | null, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> }>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } } | null, contracteeInvitations: Array<{ __typename: 'ProjectContracteeInvitation', id: string, status: Types.InvitationState, contact: { __typename: 'InvitationContact', id: string } }>, contractors: Array<{ __typename: 'CrmCompany', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } }>, invitingContractor?: { __typename: 'CrmCompany', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } } | null };

export type RowInvitingContractor_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } };

export type RowContractor_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } };

export type RowMember_ProjectMembershipFragment = { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> };

export type RowContracteeCompany_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName> };

export type RowContracteeCompany_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, email: any, logo: { __typename: 'AttachmentSnapshot', id: string, url: string, title: string } };

export type RowContracteeMember_ProjectFragment = { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName> };

export type RowContracteeMember_CrmPersonFragment = { __typename: 'CrmPerson', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type RowContracteeMember_ProjectContracteeInvitationFragment = { __typename: 'ProjectContracteeInvitation', id: string, status: Types.InvitationState };

export const RowContracteeMember_CrmPersonFragmentDoc = gql`
    fragment RowContracteeMember_CrmPerson on CrmPerson {
  id
  firstname
  familyname
  fullname
  email
  avatar {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const RowContracteeCompany_CrmCompanyFragmentDoc = gql`
    fragment RowContracteeCompany_CrmCompany on CrmCompany {
  id
  title
  email
  ...OrganisationAvatar
}
    ${OrganisationAvatarFragmentDoc}`;
export const RowMember_ProjectMembershipFragmentDoc = gql`
    fragment RowMember_ProjectMembership on ProjectMembership {
  id
  user {
    id
    firstname
    familyname
    fullname
    email
    phones {
      id
      number
    }
    avatar {
      ...AttachmentSnapshot
    }
  }
  roles {
    id
    internalName
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const RowContracteeMember_ProjectContracteeInvitationFragmentDoc = gql`
    fragment RowContracteeMember_ProjectContracteeInvitation on ProjectContracteeInvitation {
  id
  status
}
    `;
export const RowContractor_CrmCompanyFragmentDoc = gql`
    fragment RowContractor_CrmCompany on CrmCompany {
  id
  title
  ...OrganisationAvatar
}
    ${OrganisationAvatarFragmentDoc}`;
export const RowInvitingContractor_CrmCompanyFragmentDoc = gql`
    fragment RowInvitingContractor_CrmCompany on CrmCompany {
  id
  title
  ...OrganisationAvatar
}
    ${OrganisationAvatarFragmentDoc}`;
export const RowContracteeCompany_ProjectFragmentDoc = gql`
    fragment RowContracteeCompany_Project on Project {
  id
  viewerPermissions
}
    `;
export const RowContracteeMember_ProjectFragmentDoc = gql`
    fragment RowContracteeMember_Project on Project {
  id
  viewerPermissions
}
    `;
export const ProjectOverviewParticipantsBox_ProjectFragmentDoc = gql`
    fragment ProjectOverviewParticipantsBox_Project on Project {
  id
  viewerPermissions
  canInviteContractee
  crmOrganisation {
    id
    members {
      id
      ...RowContracteeMember_CrmPerson
    }
    ...RowContracteeCompany_CrmCompany
  }
  internalStakeholders {
    id
    ...RowMember_ProjectMembership
  }
  assignee {
    id
    user {
      id
      firstname
      familyname
      avatar {
        ...AttachmentSnapshot
      }
    }
  }
  contracteeInvitations {
    id
    contact {
      id
    }
    ...RowContracteeMember_ProjectContracteeInvitation
  }
  contractors {
    id
    ...RowContractor_CrmCompany
  }
  invitingContractor {
    id
    ...RowInvitingContractor_CrmCompany
  }
  ...RowContracteeCompany_Project
  ...RowContracteeMember_Project
}
    ${RowContracteeMember_CrmPersonFragmentDoc}
${RowContracteeCompany_CrmCompanyFragmentDoc}
${RowMember_ProjectMembershipFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${RowContracteeMember_ProjectContracteeInvitationFragmentDoc}
${RowContractor_CrmCompanyFragmentDoc}
${RowInvitingContractor_CrmCompanyFragmentDoc}
${RowContracteeCompany_ProjectFragmentDoc}
${RowContracteeMember_ProjectFragmentDoc}`;